import React from 'react';
import * as MuiIcons from '@mui/icons-material';
import { getNestedValue, getColorClasses } from './utils';

/**
 * DocumentCardWidget - Renders a clickable document/PDF card
 * 
 * Config structure:
 * {
 *   title: "자율안전확인 증명서",
 *   subtitle: "PDF",
 *   icon: "PictureAsPdf",
 *   iconColor: "indigo",
 *   actionType: "downloadCert",
 *   dataKey: "machine_manage_code" (optional - passed to action)
 * }
 */
export default function DocumentCardWidget({ config, data, onAction }) {
  if (!config) return null;

  const IconComponent = MuiIcons[config.icon] || MuiIcons.Description;
  const colors = getColorClasses(config.iconColor || 'indigo');

  const handleClick = () => {
    if (onAction && config.actionType) {
      let actionData = null;
      
      // Dynamic Binding
      if (config.target_table && config.target_column) {
         actionData = data[`${config.target_table}.${config.target_column}`];
      } 
      // Legacy Binding
      else if (config.dataKey) {
         actionData = getNestedValue(data, config.dataKey);
      }
      
      onAction(config.actionType, actionData);
    }
  };

  const isClickable = !!onAction && !!config.actionType;

  return (
    <div
      className={`flex items-center gap-4 p-4 rounded-2xl bg-white/5 hover:bg-white/10 transition-all ${isClickable ? 'cursor-pointer active:scale-95' : 'cursor-default'} group`}
      style={{ border: '1px solid rgba(255,255,255,0.05)' }}
      onClick={handleClick}
    >
      <div className={`w-12 h-12 rounded-xl ${colors.bgLight} flex items-center justify-center ${colors.text} group-hover:brightness-125 transition-colors`}>
        <IconComponent sx={{ fontSize: 24 }} />
      </div>
      <div className="flex-1">
        <div className="text-[13px] text-slate-200 font-black leading-tight mb-1 uppercase tracking-tight">
          {config.title}
        </div>
        <div className="text-[10px] text-slate-500 font-mono tracking-widest uppercase">
          {config.subtitle}
        </div>
      </div>
    </div>
  );
}
